const actions = {
  GET_API_JWT: 'api_middleware/GET_API_JWT',
  API_CALL: 'api_middleware/API_CALL',
};

export default actions;
